import React from 'react';
import Layout from 'sections/Layout';
import Hero from 'sections/pages/Post/Hero';
import Description from 'sections/pages/Post/Description';
import Article from 'sections/pages/Post/Article';
import Blog from 'components/Blog';
import Join from 'sections/common/Join';
import PostNavigate from 'sections/pages/Post/PostNavigate';

import useBlogPosts from 'hooks/graphql/useBlogPosts';

import 'sections/pages/Post/styles.scss';

const Post = ({ post }) => {
  const { seo } = post;

  const {
    blog: {
      banner: { sourceUrl },
    },
  } = post;

  const allPosts = useBlogPosts();

  const BLOG_DATA = {
    title: 'Manage your retail sales without a hussle',
  };

  return (
    <Layout
      currentPageClass={'cr-story-page'}
      headerClass={'cr-story-header'}
      mainClass={'cr-story-main'}
      footerClass={'cr-story-footer'}
      seo={seo}
      postBanner={sourceUrl}
    >
      {(commonData) => (
        <>
          <section className="cr-wrap cr-story__hero">
            <Hero data={post} />
          </section>

          <section className="cr-wrap cr-story-sec-border-bot cr-story__desc">
            <div className="cr-story-wrap">
              <Description data={post} />
            </div>
          </section>

          <section className="cr-wrap cr-story-sec-border-bot cr-story__article">
            <div className="cr-story-wrap">
              <Article data={post} />
            </div>
          </section>

          {allPosts.length > 1 && (
            <section className="cr-wrap cr-story-sec-border-bot cr-story__post-navigate">
              <PostNavigate data={post} />
            </section>
          )}

          <Blog data={BLOG_DATA} />

          <div className="cr-story__join">
            <Join />
          </div>
        </>
      )}
    </Layout>
  );
};

export default Post;
